import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

import { TicketingService } from '../services/ticketing-service/ticketing.service';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface IRequestOfRows {
  limit: number;
  skip: number;
  filters: any;
  conds: any;
  ordering: any;
}

@Component({
  selector: 'mcrit-gestio-ticketing',
  template: `
    <mcrit-gestio-ticketing-list
      [elementList]="elementList">
    </mcrit-gestio-ticketing-list>`,
  styleUrls: ['ticketing.component.css'],
  providers: [ TicketingService ]
})

export class TicketingComponent implements OnInit, OnDestroy {
  
  public elementList: {'offset':0, 'registers':0, 'rows': Array<any>};
  private unsubscriber : Subject<void> = new Subject<void>();

  constructor(public translate: TranslateService, public languageService: LanguageService, private requestService: TicketingService) {}

  ngOnInit(){

    this.requestService.getActive(10, 0, {}, {}, {})
      .subscribe(
        elements => { this.elementList = elements;},
        error => console.log(error)
    );

    history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

}
